import type { LocaleMessageBundle } from '../../types'

export const productMessages: LocaleMessageBundle = {
  vi: {
    'product.product.model': 'Sản phẩm',
    'product.product.title': 'Sản phẩm',
    'product.product.actions.add': 'Thêm mới',
    'product.product.actions.create': 'Thêm sản phẩm',
    'product.product.actions.createProduct': 'Hàng hóa',
    'product.product.actions.createService': 'Dịch vụ',
    'product.product.actions.createCombo': 'Combo',
    'product.product.actions.edit': 'Cập nhật',
    'product.product.actions.lock': 'Khóa',
    'product.product.actions.unlock': 'Mở khóa',
    'product.product.actions.copy': 'Sao chép',
    'product.product.actions.update': 'Cập nhật sản phẩm',
    'product.product.actions.cancel': 'Đóng',
    'product.product.actions.save': 'Lưu',
    'product.product.actions.delete': 'Xóa',
    'product.product.actions.deleteTitle': 'Xóa sản phẩm',
    'product.product.actions.retryUpload': 'Thử lại tải ảnh',
    'product.product.actions.import': 'Nhập Excel',
    'product.product.actions.export': 'Xuất Excel',
    'product.product.actions.importShort': 'Nhập',
    'product.product.actions.exportShort': 'Xuất',
    'product.product.actions.addShort': 'Thêm',
    'product.product.fields.image': 'Ảnh',
    'product.product.fields.code': 'Mã sản phẩm',
    'product.product.fields.sku': 'Mã sản phẩm',
    'product.product.fields.barcode': 'Mã vạch',
    'product.product.fields.name': 'Tên sản phẩm',
    'product.product.fields.shortName': 'Tên ngắn',
    'product.product.fields.invoiceName': 'Tên trên hóa đơn',
    'product.product.fields.type': 'Loại',
    'product.product.fields.group': 'Nhóm sản phẩm',
    'product.product.fields.brand': 'Thương hiệu',
    'product.product.fields.unit': 'Đơn vị tính',
    'product.product.fields.price': 'Giá bán',
    'product.product.fields.costPrice': 'Giá vốn',
    'product.product.fields.latestPurchasePrice': 'Giá nhập gần nhất',
    'product.product.fields.basePrice': 'Giá cơ bản',
    'product.product.fields.retailPrice': 'Giá bán lẻ',
    'product.product.fields.stock': 'Tồn kho',
    'product.product.fields.variantsCount': '{count} biến thể',
    'product.product.fields.status': 'Trạng thái',
    'product.product.fields.availabilityScope': 'Phạm vi kinh doanh',
    'product.product.fields.branches': 'Chi nhánh',
    'product.product.fields.quantity': 'Số lượng',
    'product.product.fields.purchase_price': 'Giá nhập',
    'product.product.unitConversion.title': 'Quy đổi đơn vị tính',
    'product.product.unitConversion.description':
      'Thêm các đơn vị tính khác và khai báo hệ số quy đổi so với đơn vị mặc định.',
    'product.product.unitConversion.add': 'Thêm đơn vị quy đổi',
    'product.product.unitConversion.selectBaseUnit':
      'Hãy chọn đơn vị tính mặc định trước khi thêm đơn vị quy đổi.',
    'product.product.unitConversion.empty': 'Chưa có đơn vị quy đổi nào.',
    'product.product.unitConversion.baseUnit': 'Base Unit',
    'product.product.unitConversion.ratio': 'Hệ số quy đổi',
    'product.product.unitConversion.ratioSummary': '1 đơn vị = {ratio} Base Unit',
    'product.product.unitConversion.salePrice': 'Giá bán theo đơn vị',
    'product.product.unitConversion.allowSale': 'Cho phép bán',
    'product.product.unitConversion.allowPurchase': 'Cho phép nhập',
    'product.product.unitConversion.allowInventory': 'Cho phép kiểm kho',
    'product.product.unitConversion.allowManufacturing': 'Cho phép dùng trong sản xuất',
    'product.product.unitConversion.allowTransfer': 'Cho phép chuyển kho',
    'product.product.unitConversion.allowReturn': 'Cho phép trả hàng',
    'product.product.unitConversion.decimalAllowed': 'Cho phép số lẻ',
    'product.product.unitConversion.enabled': 'Đang sử dụng',
    'product.product.unitConversion.defaultSale': 'Mặc định bán',
    'product.product.unitConversion.defaultPurchase': 'Mặc định nhập',
    'product.product.unitConversion.remove': 'Xóa đơn vị quy đổi',
    'product.product.filters.search': 'Tìm kiếm',
    'product.product.filters.trackInventory': 'Theo dõi tồn kho',
    'product.product.filters.yes': 'Có',
    'product.product.filters.no': 'Không',
    'product.product.types.product': 'Hàng hóa',
    'product.product.types.manufactured': 'Hàng sản xuất',
    'product.product.types.service': 'Dịch vụ',
    'product.product.types.combo': 'Combo',
    'product.product.status.draft': 'Nháp',
    'product.product.status.active': 'Đang bán',
    'product.product.status.inactive': 'Tạm ngưng',
    'product.product.status.archived': 'Lưu trữ',
    'product.product.availability.allBranches': 'Tất cả chi nhánh',
    'product.product.availability.selectedBranches': 'Chi nhánh được chọn',
    'product.product.tabs.overview': 'Tổng quan',
    'product.product.tabs.variants': 'Biến thể',
    'product.product.tabs.stockCard': 'Thẻ kho',
    'product.product.tabs.locations': 'Vị trí',
    'product.product.locations.title': 'Vị trí lưu kho',
    'product.product.locations.description':
      'Danh sách vị trí và số lượng tồn kho của sản phẩm theo chi nhánh.',
    'product.product.locations.location': 'Vị trí',
    'product.product.locations.locationPath': 'Đường dẫn vị trí',
    'product.product.locations.stockQuantity': 'Tồn kho tại vị trí',
    'product.product.locations.empty': 'Chưa có vị trí nào được phân bổ hàng tồn cho sản phẩm này.',
    'product.product.locations.noStock': 'Sản phẩm chưa có tồn kho tại chi nhánh này.',
    'product.product.locations.currentBranchRequired': 'Vui lòng chọn chi nhánh để xem vị trí lưu kho.',
    'product.product.locations.totalStock': 'Tổng tồn: {count}',
    'product.product.locations.allocated': 'Đã phân bổ: {count}',
    'product.product.locations.unallocated': 'Chưa phân bổ: {count}',
    'product.product.locations.manage': 'Phân bổ vị trí',
    'product.product.locations.selectVariant': 'Chọn biến thể để xem và phân bổ vị trí lưu trữ',
    'product.product.locations.variantLabel': 'Biến thể: {name}',
    'product.product.locations.allocateVariant': 'Phân bổ',
    'product.product.locations.parentOverview':
      'Sản phẩm này có {count} biến thể. Chọn từng biến thể bên dưới để phân bổ hàng tồn vào vị trí lưu trữ.',
    'product.product.stockCard.title': 'Lịch sử tồn kho',
    'product.product.stockCard.description':
      'Theo dõi toàn bộ phát sinh nhập, xuất và tồn cuối của sản phẩm.',
    'product.product.stockCard.dateFilter': 'Thời gian phát sinh',
    'product.product.stockCard.methodFilter': 'Phương thức',
    'product.product.stockCard.variant': 'Sản phẩm / biến thể',
    'product.product.stockCard.quantity': 'Số lượng',
    'product.product.stockCard.total': '{count} phát sinh',
    'product.product.stockCard.currentBranch': 'Chi nhánh: {branch}',
    'product.product.stockCard.currentBranchRequired': 'Vui lòng chọn chi nhánh để xem thẻ kho.',
    'product.product.stockCard.latestPurchasePrice': 'Giá nhập gần nhất',
    'product.product.stockCard.backToVariants': 'Quay lại biến thể',
    'product.product.detail.title': 'Chi tiết sản phẩm',
    'product.product.detail.pricing': 'Giá bán',
    'product.product.detail.inventory': 'Tồn kho',
    'product.product.detail.service': 'Dịch vụ',
    'product.product.detail.combo': 'Thành phần combo',
    'product.product.detail.createdAt': 'Ngày tạo',
    'product.product.detail.updatedAt': 'Cập nhật',
    'product.product.sections.basic': 'Thông tin cơ bản',
    'product.product.sections.pricing': 'Giá bán',
    'product.product.sections.inventory': 'Tồn kho',
    'product.product.sections.manufacturingRecipe': 'Định mức sản xuất',
    'product.product.sections.images': 'Hình ảnh',
    'product.product.sections.service': 'Thiết lập dịch vụ',
    'product.product.sections.combo': 'Thành phần combo',
    'product.product.fields.description': 'Mô tả',
    'product.product.fields.wholesalePrice': 'Giá bán sỉ',
    'product.product.fields.memberPrice': 'Giá thành viên',
    'product.product.fields.promotionalPrice': 'Giá khuyến mãi',
    'product.product.fields.trackInventory': 'Theo dõi tồn kho',
    'product.product.fields.isMaterial': 'Có thể dùng làm nguyên vật liệu',
    'product.product.fields.currentStock': 'Tồn hiện tại',
    'product.product.fields.minStock': 'Tồn tối thiểu',
    'product.product.fields.maxStock': 'Tồn tối đa',
    'product.product.fields.canSell': 'Cho phép bán',
    'product.product.fields.sellDirect': 'Bán trực tiếp',
    'product.product.fields.serviceType': 'Loại dịch vụ',
    'product.product.fields.pricingProfile': 'Cấu hình giá',
    'product.product.fields.serviceUnit': 'Đơn vị dịch vụ',
    'product.product.fields.pricePerUnit': 'Giá theo đơn vị',
    'product.product.fields.serviceDuration': 'Thời lượng',
    'product.product.fields.durationUnit': 'Đơn vị thời lượng',
    'product.product.fields.allowDiscount': 'Cho phép giảm giá',
    'product.product.fields.allowCommission': 'Cho phép hoa hồng',
    'product.product.fields.allowBooking': 'Cho phép đặt lịch',
    'product.product.inventory.trackHint': 'Quản lý tồn kho và cảnh báo',
    'product.product.fields.openingStock': 'Tồn đầu kỳ',
    'product.product.fields.initialStockBranch': 'Chi nhánh gán tồn',
    'product.product.inventory.openingStockHint':
      'Tồn đầu kỳ được ghi vào chi nhánh đang đăng nhập. Các chi nhánh khác = 0 cho đến khi nhập kho/tồn đầu kỳ.',
    'product.product.serviceTypes.fixed': 'Cố định',
    'product.product.serviceTypes.time_based': 'Theo thời gian',
    'product.product.serviceTypes.subscription': 'Định kỳ',
    'product.product.serviceTypes.package': 'Gói',
    'product.product.pricingProfiles.standard': 'Tiêu chuẩn',
    'product.product.pricingProfiles.fixed_hourly': 'Theo giờ cố định',
    'product.product.combo.addItem': 'Thêm thành phần',
    'product.product.combo.component': 'Hàng thành phần',
    'product.product.combo.selectProduct': 'Chọn sản phẩm thành phần',
    'product.product.combo.name': 'Tên sản phẩm',
    'product.product.combo.unit': 'Đơn vị tính',
    'product.product.combo.costPrice': 'Đơn giá nhập',
    'product.product.combo.salePrice': 'Đơn giá bán',
    'product.product.combo.quantity': 'Số lượng',
    'product.product.combo.empty': 'Chưa có sản phẩm nào trong combo.',
    'product.product.combo.totalCost': 'Tổng tiền đơn giá',
    'product.product.combo.totalSale': 'Tổng tiền bán',
    'product.product.combo.removeItem': 'Xóa thành phần',
    'product.product.manufacturing.description':
      'Khai báo lượng nguyên vật liệu cần dùng để tạo ra một đơn vị thành phẩm. Định mức sẽ được áp dụng ngay sau khi lưu sản phẩm.',
    'product.product.manufacturing.selectMaterial': 'Chọn nguyên vật liệu',
    'product.product.manufacturing.material': 'Nguyên vật liệu',
    'product.product.manufacturing.unit': 'Đơn vị tính',
    'product.product.manufacturing.quantity': 'Số lượng',
    'product.product.manufacturing.costPrice': 'Giá vốn',
    'product.product.manufacturing.salePrice': 'Giá bán',
    'product.product.manufacturing.estimatedCost': 'Chi phí dự kiến',
    'product.product.manufacturing.estimatedSale': 'Thành tiền bán',
    'product.product.manufacturing.totalEstimatedCost': 'Tổng giá vốn thành phần',
    'product.product.manufacturing.totalEstimatedSale': 'Tổng giá bán thành phần',
    'product.product.manufacturing.removeMaterial': 'Xóa nguyên vật liệu',
    'product.product.manufacturing.empty': 'Chưa có nguyên vật liệu trong định mức.',
    'product.product.variant.manage': 'Quản lý biến thể',
    'product.product.variant.empty': 'Chưa có biến thể.',
    'product.product.variant.attributes': 'Thuộc tính',
    'product.product.variant.stopSelling': 'Ngừng bán',
    'product.product.variant.title': 'Quản lý biến thể',
    'product.product.variant.generate': 'Sinh biến thể',
    'product.product.variant.addRow': 'Thêm biến thể',
    'product.product.variant.saveRow': 'Lưu dòng',
    'product.product.variant.saveAll': 'Lưu biến thể',
    'product.product.variant.deleteRow': 'Xóa',
    'product.product.variant.clearAll': 'Xóa hết',
    'product.product.variant.deleteBlocked': 'Biến thể đã phát sinh giao dịch, không thể xóa.',
    'product.product.variant.attributeName': 'Tên thuộc tính',
    'product.product.variant.attributeValues': 'Giá trị',
    'product.product.variant.addAttribute': 'Thêm thuộc tính',
    'product.product.variant.attributeHint':
      'Nhập tên thuộc tính và các giá trị, cách nhau bởi dấu phẩy.',
    'product.product.variant.attributeValuesPlaceholder': 'VD: Đỏ, Xanh, Đen',
    'product.product.variant.listTitle': 'Danh sách biến thể',
    'product.product.variant.image': 'Ảnh',
    'product.product.variant.chooseImage': 'Chọn ảnh',
    'product.product.variant.clearImage': 'Gỡ ảnh',
    'product.product.variant.sku': 'Mã sản phẩm',
    'product.product.variant.barcode': 'Mã vạch',
    'product.product.variant.name': 'Tên biến thể',
    'product.product.variant.costPrice': 'Giá vốn',
    'product.product.variant.retailPrice': 'Giá bán',
    'product.product.variant.stock': 'Tồn kho',
    'product.product.variant.status': 'Trạng thái',
    'product.product.variant.sellDirect': 'Bán trực tiếp',
    'product.product.variant.pricingProfile': 'Cấu hình giá',
    'product.product.variant.pricePerUnit': 'Giá theo đơn vị',
    'product.product.variant.editVariant': 'Chỉnh sửa biến thể',
    'product.product.variant.done': 'Hoàn tất',
    'product.product.variant.close': 'Đóng',
    'product.product.variant.validation.attributesRequired': 'Cần nhập ít nhất một thuộc tính.',
    'product.product.variant.validation.rowRequired':
      'Mã sản phẩm, tên biến thể và thuộc tính là bắt buộc.',
    'product.product.validation.comboItemRequired': 'Cần thêm ít nhất một thành phần combo.',
    'product.product.validation.manufacturingMaterialRequired':
      'Cần khai báo đầy đủ ít nhất một nguyên vật liệu cho hàng sản xuất.',
    'product.product.validation.manufacturingQuantityPositive':
      'Số lượng nguyên vật liệu phải lớn hơn 0.',
    'product.product.validation.manufacturingQuantityPrecision':
      'Số lượng nguyên vật liệu chỉ được có tối đa 3 chữ số thập phân.',
    'product.product.validation.requiredUnit': 'Đơn vị tính là bắt buộc.',
    'product.product.deleteConfirm': 'Bạn có chắc muốn xóa sản phẩm {name}?',
    'product.product.upload.chooseImages': 'Chọn ảnh',
    'product.product.upload.imageHint': 'PNG, JPG, JPEG (Tối đa 5MB)',
    'product.product.validation.requiredName': 'Tên sản phẩm là bắt buộc.',
    'product.product.errors.saveFailed': 'Không thể lưu sản phẩm. Vui lòng thử lại.',
    'product.product.errors.uploadFailed': 'Sản phẩm đã được lưu nhưng tải ảnh thất bại.',
    'product.product.export.error': 'Không thể xuất danh sách sản phẩm.',
    'product.product.import.title': 'Import danh sách sản phẩm',
    'product.product.import.subtitle': 'Tải file mẫu, nhập dữ liệu rồi kiểm tra trước khi lưu.',
    'product.product.import.templateTitle': 'Tải file mẫu',
    'product.product.import.templateDescription':
      'File mẫu có sẵn hướng dẫn và danh mục mã đang sử dụng.',
    'product.product.import.downloadTemplate': 'Tải file mẫu Excel',
    'product.product.import.requiredLegend': 'Thông tin bắt buộc.',
    'product.product.import.conditionalLegend':
      'Thông tin bắt buộc theo điều kiện ghi trong hướng dẫn.',
    'product.product.import.notes.scope':
      'Phiên bản này hỗ trợ hàng hóa và dịch vụ; chưa hỗ trợ combo, biến thể, ảnh hoặc đơn vị quy đổi.',
    'product.product.import.notes.codes':
      'Dùng đúng mã nhóm, thương hiệu, đơn vị tính và chi nhánh trong sheet Danh mục.',
    'product.product.import.notes.stock':
      'Hàng hóa có tồn đầu kỳ phải khai báo mã chi nhánh nhận tồn.',
    'product.product.import.notes.values':
      'Các giá trị nhiều mã ngăn cách bằng dấu chấm phẩy (;); các cột Có/Không cũng nhận true/false.',
    'product.product.import.fileTitle': 'Chọn file cần import',
    'product.product.import.fileDescription':
      'Hệ thống sẽ kiểm tra từng dòng trước khi tạo sản phẩm.',
    'product.product.import.chooseFile': 'Chọn file Excel',
    'product.product.import.supportedFormats': 'Hỗ trợ .xlsx, .xls; tối đa 5 MB',
    'product.product.import.loadingCatalog': 'Đang tải danh mục để đối chiếu dữ liệu...',
    'product.product.import.retry': 'Thử lại',
    'product.product.import.summary.total': 'Tổng: {count}',
    'product.product.import.summary.valid': 'Hợp lệ: {count}',
    'product.product.import.summary.invalid': 'Có lỗi: {count}',
    'product.product.import.errorListTitle': 'Các dòng cần kiểm tra',
    'product.product.import.rowLabel': 'Dòng {row}',
    'product.product.import.process': 'Import {count} sản phẩm',
    'product.product.import.result':
      'Đã import thành công {success} sản phẩm; {failed} dòng không được import.',
    'product.product.import.errors.invalidFileType':
      'Chỉ hỗ trợ file Excel định dạng .xlsx hoặc .xls.',
    'product.product.import.errors.fileTooLarge': 'File vượt quá dung lượng tối đa 5 MB.',
    'product.product.import.errors.noRows': 'File không có dòng dữ liệu sản phẩm.',
    'product.product.import.errors.cannotRead':
      'Không thể đọc file. Hãy dùng đúng file mẫu và thử lại.',
    'product.product.import.errors.rowFailed': 'Không thể tạo sản phẩm ở dòng này.',
    'product.product.import.errors.templateDownloadFailed':
      'Không thể tải file mẫu. Vui lòng thử lại.',
    'product.product.import.errors.catalogLoadFailed':
      'Không thể tải danh mục đối chiếu. Vui lòng thử lại.',
  },
  en: {
    'product.product.model': 'Product',
    'product.product.title': 'Products',
    'product.product.actions.add': 'Create',
    'product.product.actions.create': 'Create product',
    'product.product.actions.createProduct': 'Product',
    'product.product.actions.createService': 'Service',
    'product.product.actions.createCombo': 'Combo',
    'product.product.actions.edit': 'Edit',
    'product.product.actions.lock': 'Lock',
    'product.product.actions.unlock': 'Unlock',
    'product.product.actions.copy': 'Copy',
    'product.product.actions.update': 'Update product',
    'product.product.actions.cancel': 'Cancel',
    'product.product.actions.save': 'Save',
    'product.product.actions.delete': 'Delete',
    'product.product.actions.deleteTitle': 'Delete product',
    'product.product.actions.retryUpload': 'Retry image upload',
    'product.product.actions.import': 'Import Excel',
    'product.product.actions.export': 'Export Excel',
    'product.product.actions.importShort': 'Import',
    'product.product.actions.exportShort': 'Export',
    'product.product.actions.addShort': 'Add',
    'product.product.fields.image': 'Image',
    'product.product.fields.code': 'Product code',
    'product.product.fields.sku': 'SKU',
    'product.product.fields.barcode': 'Barcode',
    'product.product.fields.name': 'Product name',
    'product.product.fields.shortName': 'Short name',
    'product.product.fields.invoiceName': 'Invoice name',
    'product.product.fields.type': 'Type',
    'product.product.fields.group': 'Product group',
    'product.product.fields.brand': 'Brand',
    'product.product.fields.unit': 'Unit',
    'product.product.fields.price': 'Price',
    'product.product.fields.costPrice': 'Cost price',
    'product.product.fields.latestPurchasePrice': 'Latest purchase price',
    'product.product.fields.basePrice': 'Base price',
    'product.product.fields.retailPrice': 'Retail price',
    'product.product.fields.stock': 'Stock',
    'product.product.fields.variantsCount': '{count} variants',
    'product.product.fields.status': 'Status',
    'product.product.fields.availabilityScope': 'Availability scope',
    'product.product.fields.branches': 'Branches',
    'product.product.fields.quantity': 'Quantity',
    'product.product.fields.purchase_price': 'Purchase price',
    'product.product.unitConversion.title': 'Unit conversion',
    'product.product.unitConversion.description':
      'Add other units and configure their ratios to the default unit.',
    'product.product.unitConversion.add': 'Add conversion unit',
    'product.product.unitConversion.selectBaseUnit':
      'Select a default unit before adding conversion units.',
    'product.product.unitConversion.empty': 'No conversion units added yet.',
    'product.product.unitConversion.baseUnit': 'Base Unit',
    'product.product.unitConversion.ratio': 'Conversion ratio',
    'product.product.unitConversion.ratioSummary': '1 unit = {ratio} Base Units',
    'product.product.unitConversion.salePrice': 'Sale price per unit',
    'product.product.unitConversion.allowSale': 'Allow sale',
    'product.product.unitConversion.allowPurchase': 'Allow purchase',
    'product.product.unitConversion.allowInventory': 'Allow inventory count',
    'product.product.unitConversion.allowManufacturing': 'Allow manufacturing',
    'product.product.unitConversion.allowTransfer': 'Allow transfer',
    'product.product.unitConversion.allowReturn': 'Allow return',
    'product.product.unitConversion.decimalAllowed': 'Allow decimals',
    'product.product.unitConversion.enabled': 'Enabled',
    'product.product.unitConversion.defaultSale': 'Default sale',
    'product.product.unitConversion.defaultPurchase': 'Default purchase',
    'product.product.unitConversion.remove': 'Remove conversion unit',
    'product.product.filters.search': 'Search',
    'product.product.filters.trackInventory': 'Track inventory',
    'product.product.fields.openingStock': 'Opening stock',
    'product.product.fields.initialStockBranch': 'Stock branch',
    'product.product.filters.yes': 'Yes',
    'product.product.filters.no': 'No',
    'product.product.types.product': 'Product',
    'product.product.types.manufactured': 'Manufactured product',
    'product.product.types.service': 'Service',
    'product.product.types.combo': 'Combo',
    'product.product.status.draft': 'Draft',
    'product.product.status.active': 'Active',
    'product.product.status.inactive': 'Inactive',
    'product.product.status.archived': 'Archived',
    'product.product.availability.allBranches': 'All branches',
    'product.product.availability.selectedBranches': 'Selected branches',
    'product.product.tabs.overview': 'Overview',
    'product.product.tabs.variants': 'Variants',
    'product.product.tabs.stockCard': 'Stock card',
    'product.product.tabs.locations': 'Locations',
    'product.product.locations.title': 'Storage locations',
    'product.product.locations.description':
      'List of storage locations and inventory quantities of this product by branch.',
    'product.product.locations.location': 'Location',
    'product.product.locations.locationPath': 'Location path',
    'product.product.locations.stockQuantity': 'Stock at location',
    'product.product.locations.empty': 'No location allocations for this product yet.',
    'product.product.locations.noStock': 'No stock available for this product in this branch.',
    'product.product.locations.currentBranchRequired': 'Select a branch to view storage locations.',
    'product.product.locations.totalStock': 'Total stock: {count}',
    'product.product.locations.allocated': 'Allocated: {count}',
    'product.product.locations.unallocated': 'Unallocated: {count}',
    'product.product.locations.manage': 'Manage allocations',
    'product.product.locations.selectVariant': 'Select a variant to view and allocate storage locations',
    'product.product.locations.variantLabel': 'Variant: {name}',
    'product.product.locations.allocateVariant': 'Allocate',
    'product.product.locations.parentOverview':
      'This product has {count} variants. Select each variant below to allocate inventory to storage locations.',
    'product.product.stockCard.title': 'Inventory history',
    'product.product.stockCard.description':
      'Track all stock receipts, issues, and ending balances for this product.',
    'product.product.stockCard.dateFilter': 'Occurred date',
    'product.product.stockCard.methodFilter': 'Method',
    'product.product.stockCard.variant': 'Product / variant',
    'product.product.stockCard.quantity': 'Quantity',
    'product.product.stockCard.total': '{count} movements',
    'product.product.stockCard.currentBranch': 'Branch: {branch}',
    'product.product.stockCard.currentBranchRequired': 'Select a branch to view the stock card.',
    'product.product.stockCard.latestPurchasePrice': 'Latest purchase price',
    'product.product.stockCard.backToVariants': 'Back to variants',
    'product.product.detail.title': 'Product detail',
    'product.product.detail.pricing': 'Pricing',
    'product.product.detail.inventory': 'Inventory',
    'product.product.detail.service': 'Service',
    'product.product.detail.combo': 'Combo items',
    'product.product.detail.createdAt': 'Created',
    'product.product.detail.updatedAt': 'Updated',
    'product.product.sections.basic': 'Basic information',
    'product.product.sections.pricing': 'Pricing',
    'product.product.sections.inventory': 'Inventory',
    'product.product.sections.manufacturingRecipe': 'Manufacturing recipe',
    'product.product.sections.images': 'Images',
    'product.product.sections.service': 'Service settings',
    'product.product.sections.combo': 'Combo items',
    'product.product.fields.description': 'Description',
    'product.product.fields.wholesalePrice': 'Wholesale price',
    'product.product.fields.memberPrice': 'Member price',
    'product.product.fields.promotionalPrice': 'Promotional price',
    'product.product.fields.trackInventory': 'Track inventory',
    'product.product.fields.isMaterial': 'Can be used as material',
    'product.product.fields.currentStock': 'Current stock',
    'product.product.fields.minStock': 'Minimum stock',
    'product.product.fields.maxStock': 'Maximum stock',
    'product.product.fields.canSell': 'Can sell',
    'product.product.fields.sellDirect': 'Sell directly',
    'product.product.fields.serviceType': 'Service type',
    'product.product.fields.pricingProfile': 'Pricing profile',
    'product.product.fields.serviceUnit': 'Service unit',
    'product.product.fields.pricePerUnit': 'Price per unit',
    'product.product.fields.serviceDuration': 'Duration',
    'product.product.fields.durationUnit': 'Duration unit',
    'product.product.fields.allowDiscount': 'Allow discount',
    'product.product.fields.allowCommission': 'Allow commission',
    'product.product.fields.allowBooking': 'Allow booking',
    'product.product.inventory.trackHint': 'Stock management and alerts',
    'product.product.inventory.openingStockHint':
      'Opening stock is recorded for the currently logged-in branch. Other branches stay at 0 until receipt/opening stock is posted.',
    'product.product.serviceTypes.fixed': 'Fixed',
    'product.product.serviceTypes.time_based': 'Time based',
    'product.product.serviceTypes.subscription': 'Subscription',
    'product.product.serviceTypes.package': 'Package',
    'product.product.pricingProfiles.standard': 'Standard',
    'product.product.pricingProfiles.fixed_hourly': 'Fixed hourly',
    'product.product.combo.addItem': 'Add item',
    'product.product.combo.component': 'Component',
    'product.product.combo.selectProduct': 'Select component product',
    'product.product.combo.name': 'Product name',
    'product.product.combo.unit': 'Unit',
    'product.product.combo.costPrice': 'Purchase unit price',
    'product.product.combo.salePrice': 'Sale unit price',
    'product.product.combo.quantity': 'Quantity',
    'product.product.combo.empty': 'No products selected for this combo.',
    'product.product.combo.totalCost': 'Total purchase amount',
    'product.product.combo.totalSale': 'Total sale amount',
    'product.product.combo.removeItem': 'Remove item',
    'product.product.manufacturing.description':
      'Specify the material quantities needed to produce one finished unit. The recipe is activated when the product is saved.',
    'product.product.manufacturing.selectMaterial': 'Select material',
    'product.product.manufacturing.material': 'Material',
    'product.product.manufacturing.unit': 'Unit',
    'product.product.manufacturing.quantity': 'Quantity',
    'product.product.manufacturing.costPrice': 'Cost price',
    'product.product.manufacturing.salePrice': 'Sale price',
    'product.product.manufacturing.estimatedCost': 'Estimated cost',
    'product.product.manufacturing.estimatedSale': 'Estimated sale value',
    'product.product.manufacturing.totalEstimatedCost': 'Total material cost',
    'product.product.manufacturing.totalEstimatedSale': 'Total material sale value',
    'product.product.manufacturing.removeMaterial': 'Remove material',
    'product.product.manufacturing.empty': 'No materials have been added to this recipe.',
    'product.product.variant.manage': 'Manage variants',
    'product.product.variant.empty': 'No variants yet.',
    'product.product.variant.attributes': 'Attributes',
    'product.product.variant.stopSelling': 'Stop selling',
    'product.product.variant.title': 'Manage variants',
    'product.product.variant.generate': 'Generate variants',
    'product.product.variant.addRow': 'Add variant',
    'product.product.variant.saveRow': 'Save row',
    'product.product.variant.saveAll': 'Save variants',
    'product.product.variant.deleteRow': 'Delete',
    'product.product.variant.clearAll': 'Clear all',
    'product.product.variant.deleteBlocked':
      'This variant already has transactions and cannot be deleted.',
    'product.product.variant.attributeName': 'Attribute name',
    'product.product.variant.attributeValues': 'Values',
    'product.product.variant.addAttribute': 'Add attribute',
    'product.product.variant.attributeHint': 'Enter attribute names and comma-separated values.',
    'product.product.variant.attributeValuesPlaceholder': 'e.g. Red, Blue, Black',
    'product.product.variant.listTitle': 'Variant list',
    'product.product.variant.image': 'Image',
    'product.product.variant.chooseImage': 'Choose image',
    'product.product.variant.clearImage': 'Remove image',
    'product.product.variant.sku': 'SKU',
    'product.product.variant.barcode': 'Barcode',
    'product.product.variant.name': 'Variant name',
    'product.product.variant.costPrice': 'Cost price',
    'product.product.variant.retailPrice': 'Retail price',
    'product.product.variant.stock': 'Stock',
    'product.product.variant.status': 'Status',
    'product.product.variant.sellDirect': 'Sell directly',
    'product.product.variant.pricingProfile': 'Pricing profile',
    'product.product.variant.pricePerUnit': 'Price per unit',
    'product.product.variant.editVariant': 'Edit variant',
    'product.product.variant.done': 'Done',
    'product.product.variant.close': 'Close',
    'product.product.variant.validation.attributesRequired': 'Enter at least one attribute.',
    'product.product.variant.validation.rowRequired':
      'SKU, variant name, and attributes are required.',
    'product.product.validation.comboItemRequired': 'Add at least one combo item.',
    'product.product.validation.manufacturingMaterialRequired':
      'Add at least one complete material line for the manufactured product.',
    'product.product.validation.manufacturingQuantityPositive':
      'Material quantity must be greater than 0.',
    'product.product.validation.manufacturingQuantityPrecision':
      'Material quantity can have at most 3 decimal places.',
    'product.product.validation.requiredUnit': 'Product unit is required.',
    'product.product.deleteConfirm': 'Are you sure you want to delete product {name}?',
    'product.product.upload.chooseImages': 'Choose images',
    'product.product.upload.imageHint': 'PNG, JPG, JPEG (Max 5MB)',
    'product.product.validation.requiredName': 'Product name is required.',
    'product.product.errors.saveFailed': 'Unable to save product. Please try again.',
    'product.product.errors.uploadFailed': 'Product was saved but image upload failed.',
    'product.product.export.error': 'Unable to export the product list.',
    'product.product.import.title': 'Import products',
    'product.product.import.subtitle':
      'Download the template, enter data, and validate it before saving.',
    'product.product.import.templateTitle': 'Download template',
    'product.product.import.templateDescription':
      'The template includes instructions and the current code catalogs.',
    'product.product.import.downloadTemplate': 'Download Excel template',
    'product.product.import.requiredLegend': 'Required information.',
    'product.product.import.conditionalLegend': 'Conditionally required as described in the guide.',
    'product.product.import.notes.scope':
      'This version supports products and services; combos, variants, images, and unit conversions are not supported.',
    'product.product.import.notes.codes':
      'Use category, brand, unit, and branch codes from the Catalog sheet.',
    'product.product.import.notes.stock':
      'Products with opening stock must specify the branch receiving that stock.',
    'product.product.import.notes.values':
      'Separate multiple codes with semicolons (;); Yes/No columns also accept true/false.',
    'product.product.import.fileTitle': 'Choose an import file',
    'product.product.import.fileDescription': 'Each row is validated before a product is created.',
    'product.product.import.chooseFile': 'Choose Excel file',
    'product.product.import.supportedFormats': 'Supports .xlsx and .xls; maximum 5 MB',
    'product.product.import.loadingCatalog': 'Loading catalogs used to validate the data...',
    'product.product.import.retry': 'Retry',
    'product.product.import.summary.total': 'Total: {count}',
    'product.product.import.summary.valid': 'Valid: {count}',
    'product.product.import.summary.invalid': 'Invalid: {count}',
    'product.product.import.errorListTitle': 'Rows to review',
    'product.product.import.rowLabel': 'Row {row}',
    'product.product.import.process': 'Import {count} products',
    'product.product.import.result':
      'Successfully imported {success} products; {failed} rows were not imported.',
    'product.product.import.errors.invalidFileType':
      'Only .xlsx or .xls Excel files are supported.',
    'product.product.import.errors.fileTooLarge': 'The file exceeds the 5 MB maximum size.',
    'product.product.import.errors.noRows': 'The file contains no product data rows.',
    'product.product.import.errors.cannotRead':
      'Unable to read the file. Use the provided template and try again.',
    'product.product.import.errors.rowFailed': 'Unable to create the product on this row.',
    'product.product.import.errors.templateDownloadFailed':
      'Unable to download the template. Please try again.',
    'product.product.import.errors.catalogLoadFailed':
      'Unable to load validation catalogs. Please try again.',
  },
}
